import "./css/firstdesc.css";
import React from "react";

function About() {
  return (
    <div className="first">
      <div className="first_content">
        <p>
          <span className="first-bold">Sweets Collection</span> offers home made food
          products and cooked snacks. Usually, all of our products are made
          without Onion and Garlic. However, due to customer demands, we are
          offering 3 items with Garlic. Please select the required items
          accordingly. Visit each products for more information and best
          results.
          <br />
          <br />
          We also undertake orders for Marriage & Upanayana (Chakkli, Puri Unde
          & other items). Please contact us for bulk orders.
        </p>
      </div>
    </div>
  );
}

export default About;
